import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Route from "./Route";
import RouteComp from "./Route";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RouteComp />);
